import React, { useState } from "react";
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { HTMLElementsWithHoverEffect, NotificationsReceived } from "../../../../Constant";
import { HOVER_TOOLTIP_DATA, HOVER_TOOLTIP_LIST } from "../../../../Data/UiKit/Tooltip";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonTooltip from "../Common/CommonTooltip";

const ElementsWithHoverEffect = () => {
  const [tooltip, setTooltip] = useState(false);
  const toggle = () => setTooltip(!tooltip);
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={HTMLElementsWithHoverEffect} span={HOVER_TOOLTIP_DATA} />
        <CardBody>
          <div className="common-flex">
            <Btn id="Tooltip-12" className="bg-primary mb-0 me-0">{NotificationsReceived}</Btn>
            <ToolTip isOpen={tooltip} toggle={toggle} placement="top" target="Tooltip-12"><i>Thank </i> <u>you</u></ToolTip>
            {HOVER_TOOLTIP_LIST.map((data) => (
              <CommonTooltip key={data.id} item={data} />
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ElementsWithHoverEffect;
